module.exports = __webpack_public_path__ + "static/media/decision_making_1_closeup.8cb83253.png";